import { isLocaleAvailableForPlatform } from "@js2/utils";
import {
  IntegrationType,
  IReanalyzeSample,
  IReanalyzeValues
} from "@modules/samples/@types";
import { InteractiveParams, RlcsParams } from "../reanalyze-form";

export const getLocaleForPlatform = (locale?: string, platform?: string) =>
  isLocaleAvailableForPlatform(platform) ? locale : undefined;

// `InteractiveParams.execution_timeout` must map to the backend's
// `interactive_timeout` field (see `ReanalyzeSerializer` in
// samples/serializers/__init__.py and `AdvancedFetchSerializer` in
// fetch_analyze/serializers.py) rather than the naive
// `interactive_execution_timeout` a blind prefix would produce —
// otherwise the value silently never reaches the server and is never
// validated (or applied) at all.
const INTERACTIVE_KEY_MAP: Partial<Record<keyof InteractiveParams, string>> = {
  execution_timeout: "timeout"
};

export const prepareInteractiveParams = (
  interactiveParams: InteractiveParams
) =>
  Object.entries(interactiveParams).reduce<
    Record<string, InteractiveParams[keyof InteractiveParams]>
  >(
    (acc, [key, value]) => ({
      ...acc,
      [`interactive_${
        INTERACTIVE_KEY_MAP[key as keyof InteractiveParams] ?? key
      }`]: value
    }),
    {}
  );

export const prepareDataForApi = (
  values: IReanalyzeValues,
  rlcsParams: RlcsParams,
  interactiveParams: InteractiveParams,
  samples: IReanalyzeSample[]
) => {
  const tools: Array<IntegrationType> = Object.keys(values)
    .filter(key => values[key as keyof typeof values])
    .map(key => key as IntegrationType);

  const { locale, platform } = rlcsParams ?? {};

  const interactive = prepareInteractiveParams(interactiveParams);

  return {
    integrations: tools,
    samples,
    ...rlcsParams,
    ...(!values.local_only && interactive),
    locale: getLocaleForPlatform(locale, platform)
  };
};
